import { useState } from "react";
import Modal from "../../lib/ui/components/Modal";
import Badge from "../../lib/ui/components/badge/Badge";
import Tooltip from "../../lib/ui/components/tooltip/Tooltip";
import { LabelText, SmallText, XsmallText } from "../../lib/ui/components/typography/Typography";
import { listAtsApplications } from "./atsApplications";
import "./MultipleApplicationsModal.css";

export default function MultipleApplicationsModal({ show, onClose, applicant }) {
  const [copiedApplicationId, setCopiedApplicationId] = useState(null);

  const handleClose = () => {
    setCopiedApplicationId(null);
    onClose();
  };

  return (
    <Modal
      show={show}
      onClose={handleClose}
      size="lg"
      dismissible
      className="applications-modal"
    >
      <Modal.Header>Multiple Applications</Modal.Header>
      <Modal.Body className="max-h-[min(34rem,72vh)] overflow-y-auto pr-6">
        <SmallText className="mb-4 block text-gray-600">
          This candidate applied to this role more than once. June only interviews the current application. Rejecting the candidate closes all of these applications.
        </SmallText>
        <div className="space-y-3">
          {listAtsApplications(applicant).map((application) => (
            <div
              key={application.ats_application_id}
              className={
                application.is_active
                  ? "relative rounded-lg border border-[var(--primary-200)] bg-white p-4"
                  : application.is_declined
                    ? "relative rounded-lg border border-gray-200 bg-gray-50 p-4"
                    : "relative rounded-lg border border-gray-200 bg-white p-4"
              }
            >
              {(application.is_active || application.is_declined) && (
                <div className="absolute right-3 top-3 flex flex-wrap justify-end gap-1">
                  {application.is_active && (
                    <Badge variant="purple">Current</Badge>
                  )}
                  {application.is_declined && (
                    <Badge variant="gray">Declined</Badge>
                  )}
                </div>
              )}
              <LabelText
                weight="bold"
                emphasis={false}
                className={`mb-1 block${
                  application.is_active || application.is_declined ? " pr-24" : ""
                }`}
              >
                {application.ats_current_stage_name?.trim() || "No stage"}
              </LabelText>
              <Tooltip
                content={
                  copiedApplicationId === application.ats_application_id
                    ? "Copied!"
                    : "Copy"
                }
              >
                <button
                  type="button"
                  className="block cursor-pointer text-left text-body text-gray-400 hover:text-gray-600"
                  onClick={() => {
                    const applicationId = application.ats_application_id;
                    if (!applicationId) return;
                    navigator.clipboard.writeText(applicationId).then(() => {
                      setCopiedApplicationId(applicationId);
                    });
                  }}
                >
                  {application.ats_application_id}
                </button>
              </Tooltip>
              {application.created_at && (
                <XsmallText className="mt-1 block text-gray-500">
                  First seen{" "}
                  {new Date(application.created_at).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                </XsmallText>
              )}
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
}
